"use strict";

function findApp(obj) {
  if (obj) {
    if (obj.context && obj.context.app) {
      return obj.context.app;
    }

    if (obj.props && obj.props.app) {
      return obj.props.app;
    }
  }
}

module.exports = findApp;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/core/findApp.js
 ** module id = 77
 ** module chunks = 0
 **/